import { Directive, AfterViewInit, ElementRef } from '@angular/core';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';

@Directive({
	selector: '[infiniteScrollFix]',
	standalone: true
})
export class InfiniteScrollFixDirective implements AfterViewInit {

	constructor(
		private container: ElementRef,
		private infiniteScrollDirective: InfiniteScrollDirective
	) {}

	ngAfterViewInit(): void {
		if (this.shouldTriggerScroll()) {
			this.infiniteScrollDirective?.scrolled.emit();
		}
	}

	private shouldTriggerScroll(): boolean {
		const el: HTMLDivElement = this.container?.nativeElement;
		return el && el.scrollHeight <= el.clientHeight;
	}
}